import React from 'react';
import { Form, Input, Select, Typography, Switch, Row, Col, InputNumber } from 'antd';

const { Text } = Typography;
const { Option } = Select;

const CsvWriterNodeProperties = ({ config, inputSchema }) => {
  return (
    <>
      <Form.Item label="File Name" name="fileName" initialValue={config.fileName || 'export.csv'} rules={[{ required: true }]}>
        <Input placeholder="e.g., output.csv or data_{{timestamp}}.csv" />
      </Form.Item>

      <Form.Item label="File Path" name="filePath" initialValue={config.filePath || './exports/'}>
        <Input placeholder="Directory path for output file" />
      </Form.Item>

      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Delimiter" name="delimiter" initialValue={config.delimiter || ','}>
            <Select>
              <Option value=",">Comma (,)</Option>
              <Option value=";">Semicolon (;)</Option>
              <Option value="\t">Tab (\t)</Option>
              <Option value="|">Pipe (|)</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Encoding" name="encoding" initialValue={config.encoding || 'utf-8'}>
            <Select>
              <Option value="utf-8">UTF-8</Option>
              <Option value="utf-16">UTF-16</Option>
              <Option value="ascii">ASCII</Option>
              <Option value="latin1">Latin-1</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Include Headers" name="includeHeaders" initialValue={config.includeHeaders !== false} valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Quote All Fields" name="quoteAll" initialValue={config.quoteAll || false} valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Quote Character" name="quoteChar" initialValue={config.quoteChar || '"'}>
        <Input placeholder="Character used for quoting" maxLength={1} />
      </Form.Item>

      <Form.Item label="Escape Character" name="escapeChar" initialValue={config.escapeChar || '\\'}>
        <Input placeholder="Character used for escaping" maxLength={1} />
      </Form.Item>

      <Form.Item label="Columns to Export" name="columnsToExport" initialValue={config.columnsToExport || []}>
        <Select mode="tags" placeholder="Select specific columns (empty = all columns)">
          {inputSchema && inputSchema.map(col => (
            <Option key={col.name} value={col.name}>{col.name}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Column Mapping" name="columnMapping" initialValue={config.columnMapping || {}}>
        <Input.TextArea 
          rows={3}
          placeholder='{"old_column": "new_column", "another": "renamed"}'
        />
      </Form.Item>

      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Max File Size (MB)" name="maxFileSize" initialValue={config.maxFileSize || 100}>
            <InputNumber min={1} max={1000} style={{ width: '100%' }} placeholder="Split if larger" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Overwrite Existing" name="overwrite" initialValue={config.overwrite !== false} valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Date Format" name="dateFormat" initialValue={config.dateFormat || 'YYYY-MM-DD'}>
        <Input placeholder="Format for date columns (moment.js format)" />
      </Form.Item>

      <Form.Item label="Null Value Representation" name="nullValue" initialValue={config.nullValue || ''}>
        <Input placeholder="How to represent null values (empty, NULL, etc.)" />
      </Form.Item>

      <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px', marginTop: '12px' }}>
        <Text type="secondary">
          <strong>CSV Writer Node:</strong><br/>
          • Exports dataset to CSV file<br/>
          • Supports custom delimiters and encoding<br/>
          • Column selection and renaming available<br/>
          • Automatic file splitting for large datasets<br/>
          • Template variables: {'{'}timestamp{'}'}, {'{'}date{'}'}, {'{'}index{'}'}
        </Text>
      </div>
    </>
  );
};

export default CsvWriterNodeProperties;